/**
 * @generated SignedSource<<3e912c1a298c764ce77414435600de96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnswerListItem_User$data = {
  readonly configuration: {
    readonly videoMaxDuration: number | null | undefined;
    readonly videoMinDuration: number | null | undefined;
  } | null | undefined;
  readonly video: {
    readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_Video">;
  } | null | undefined;
  readonly " $fragmentType": "AnswerListItem_User";
};
export type AnswerListItem_User$key = {
  readonly " $data"?: AnswerListItem_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerListItem_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Configuration",
      "kind": "LinkedField",
      "name": "configuration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoMaxDuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoMinDuration",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Video",
      "kind": "LinkedField",
      "name": "video",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AnswerListItem_Video"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f05afa9d49590a649b3e7623e430797d";

export default node;
